import { createContext } from "react";
import type { AuthContextType } from "./types";

// Split into its own file (no component export here) so Vite/React Fast
// Refresh can treat AuthProvider.tsx as a clean component-only boundary --
// mixing a component and a plain value/hook export in one file is what
// caused "useAuth must be used within AuthProvider" after editing this
// file while the dev server was running.
export const AuthContext = createContext<AuthContextType | undefined>(undefined);
